<template>
  <div class="Market">
    <div v-for="(type, type_index) in accessories" :key="type_index">
      <div class="p-2 mb-6 mt-6 text-2xl">{{ type_index.toUpperCase() }}s</div>
      <div class="flex items-start flex-wrap space-x-6">
        <Addon
          v-on:buy-clicked="buyClicked"
          :key="addon_index"
          :addon="addon"
          v-for="(addon, addon_index) in type.addons"
          :toBuy="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Addon from "@/components/Bazaar/Addon.vue";

export default {
  name: "Market",
  components: { Addon },
  data: function () {
    return {
      balance: "",
      contract: null,
      accessories: {
        Power: {
          addons: [
            {
              title: "Powers",
              price: 250,
              id: 1,
              rarity: 100,
              quantity: 450,
              requiredhp: 50,
              img: require("@/assets/img/addons/1.jpg"),
              description: "Weekly Cashback",
              used: 0,
              detachable: false,
            },
            {
              title: "Powers",
              price: 50,
              id: 2,
              rarity: 40,
              quantity: 700,
              requiredhp: 20,
              img: require("@/assets/img/addons/2.jpg"),
              description: "Customize Pet",
              used: 0,
              detachable: true,
            },
            {
              title: "Powers",
              price: 69,
              id: 4,
              rarity: 42,
              quantity: 100,
              requiredhp: 70,
              img: require("@/assets/img/addons/3.jpg"),
              description: "Bonk Bonk",
              used: 0,
              detachable: false,
            },
          ],
        },
        // shield: {
        //   title: "Shields",
        //   addons: [],
        // },
      },
    };
  },
  methods: {
    initialize: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      let hasNextMember = true;
      let index = 1;
      while (hasNextMember) {
        let addon = await this.$store.state.vNFTxContract.methods
          .addon(index)
          .call();
        if (addon.quantity == "0") {
          hasNextMember = false;
        } else {
          // maybe add back later, for now let's keep all power
          // if (this.accessories[addon._type] == null) {
          //   this.accessories[addon._type] = { addons: [] };
          // }
          addon.id = index;

          index++;

          const found = this.accessories.Power.addons.some(
            (el) => el.id === addon.id
          );
          if (found) {
            const index = this.accessories.Power.addons.findIndex(
              (x) => x.id == addon.id
            );
            this.accessories.Power.addons[index].used = parseInt(
              addon.used.toString()
            );
          }
        }
      }
      console.log(this.accessories);
    },
    buyClicked: async function (id, addon) {
      let hasTokenApproval =
        (
          await this.$store.state.MuseTokenContract.methods
            .allowance(
              this.$store.state.account,
              this.$store.state.contracts.vNFTx
            )
            .call()
        ).length >= 18;
      if (!hasTokenApproval) {
        await this.approve();
      }
      const tokenId = prompt(
        `This addon costs ${addon.price} $muse. To which vNFT would you like to give it to?`
      );
      let buytx = await this.$store.state.vNFTxContract.methods
        .buyAddon(tokenId, id)
        .send({
          from: this.$store.state.account,
        });
    },
    approve: async function () {
      let max =
        "115792089237316195423570985008687907853269984665640564039457584007913129639935";
      let minetx = await this.$store.state.MuseTokenContract.methods
        .approve(this.$store.state.contracts.vNFTx, max)
        .send({
          from: this.$store.state.account,
        });
    },
  },
  beforeMount: async function () {
    await this.initialize();
  },
  watch: {
    isConnected: async function () {
      await this.initialize();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
